import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { Toast } from "../../components";
import * as Yup from "yup";
import AuthLayout from "../../layout/AuthLayout";
import CheckBtn2 from "../../components/CheckBtn/checkButton";
import PhoneInput from "react-phone-input-2";
import { Link, useHistory } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import { availability } from "../../redux/auth/actions";
import { api } from "../../utils/constants";
import axios from "../../redux/axios";
import "./auth.scss";
import { Helmet } from "react-helmet";

function SignUp() {
  const initialValues = {
    firstName: "",
    middleName: "",
    lastName: "",
    emailAddress: "",
  };
  const [userexist, setUserexist] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneerror, setPhoneerror] = useState(false);
  const [agree, setAgree] = useState(false);
  const [terms, setTerms] = useState(false);
  const [numExist, setNumExist] = useState(false);
  const [dontSum, setDontSum] = useState(false);
  const [fn, setFn] = useState("");
  const [mn, setMn] = useState("");
  const [ln, setLn] = useState("");
  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const RegistrationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First Name Required")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
    middleName: Yup.string().matches(
      /^[aA-zZ\s]+$/,
      "Only alphabets are allowed for this field "
    ),
    lastName: Yup.string()
      .required("Last Name Required")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
    emailAddress: Yup.string().required("Email Address Name Required"),
  });

  useEffect(() => {
    if (user.isName === false) {
      setUserexist(true);
    } else {
      setUserexist(false);
    }
  }, [user.isName]);
  const [country, setCountry] = useState(234);

  // useEffect(() => {
  //   fetch("https://ipapi.co/json/")
  //     .then((res) => res.json())
  //     .then((res) => {
  //       setCountry(res.country_code.toLowerCase());
  //     })
  //     .catch((data, status) => {
  //       console.log("Request failed:", data);
  //     });
  // }, []);

  useEffect(async () => {
    if (phone.length > 10) {
      await axios
        .get(api.mobile_exist + phone)
        .then((res) => {
          if (res.data.status === "failure") {
            setNumExist(true);
            setDontSum(true);
          } else {
            setNumExist(false);
            setDontSum(false);
          }
        })
        .catch();
    }
  }, [phone]);

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues,
    validationSchema: RegistrationSchema,
    onSubmit: (values) => {
      console.log(values);
      localStorage.clear();
      if (phone.length < 10) {
        setPhoneerror(true);
      } else if (dontSum === true) {
        setNumExist(true);
      } else if (terms === false) {
        setAgree(true);
      } else {
        const email = values.emailAddress;
        const mobile = phone.toString();
        const val = { mobile, email };
        const middle =
          values.middleName === "" ? " " : values.middleName.trim();
        const Datas = {
          firstName: values.firstName,
          middleName: middle,
          lastName: values.lastName,
          phone: phone,
          emailAddress: values.emailAddress,
        };
        localStorage.setItem("regdata", JSON.stringify(Datas));
        dispatch(
          availability(val, (res) => {
            if (res.status === true) {
              localStorage.setItem("regdata", JSON.stringify(Datas));
              history.push("/setPassCode");
            }
          })
        );
      }
    },
  });

  const handlePhone = (event) => {
    if (event.length < 12) {
      setPhoneerror(true);
    } else {
      setPhoneerror(false);
      setPhone(event);
    }
  };
  const handleTextChange = (event) => {
    const result = event.target.value.replace(/[^a-z]/gi, "");
    console.log(result, "result");
    if (event.target.name == "firstName") {
      setFn(result);
    }
    if (event.target.name == "middleName") {
      setMn(result);
    }
    if (event.target.name == "lastName") {
      setLn(result);
    }
  };
  return (
    <AuthLayout>
      <Helmet>
        <title>Create Your Account | Sign Up
</title>
<meta 
            name='description' 
            content='Create your account and sign up to shop for a wide range of tests from Diagnostic Marketplace. Get the best deals, have test results delivered to you'
            />
      </Helmet>
      <div className="signupContainer">
        <Toast
          text={"User is already exist with this email/phone"}
          type="warning"
          open={userexist}
          setClose={() => {
            setUserexist(false);
          }}
        />
        <Toast
          text={"Please accept terms"}
          type="warning"
          open={agree}
          setClose={() => {
            setAgree(false);
          }}
        />
        <Toast
          text={"Mobile Number is already exist."}
          type="warning"
          open={numExist}
          setClose={() => {
            setNumExist(false);
          }}
        />

        <div className="back">
          <img
            crossOrigin="anonymous"
            style={{ height: "12px", width: "13px" }}
            src={require("../../assets/images/back.svg").default}
            alt=""
          />
          <Link to="/login">Back</Link>
        </div>
        <div className="heads">
          <label className="h2head">Create an account</label>
          <p>Enjoy personalized healthcare and start living better</p>
        </div>
        <form onSubmit={handleSubmit}>
          <label style={{ marginTop: "0px" }} htmlFor="First Name">
            First Name *
          </label>
          <div>
            <input
              placeholder="Enter your firstname"
              className="inputForm"
              onChange={handleChange}
              type="text"
              name="firstName"
              value={values.firstName}
            />
            {errors.firstName ? (
              <div className="error">{errors.firstName}</div>
            ) : null}
          </div>

          <label htmlFor="Middle Name">Middle Name</label>
          <div>
            <input
              placeholder="Enter your middlename"
              className="inputForm"
              onChange={handleChange}
              type="text"
              name="middleName"
              value={values.middleName}
            />
            {errors.middleName ? (
              <div className="error">{errors.middleName}</div>
            ) : null}
          </div>

          <label htmlFor="Last Name">Last Name *</label>
          <div>
            <input
              placeholder="Enter your lastname"
              className="inputForm"
              onChange={handleChange}
              type="text"
              name="lastName"
              value={values.lastName}
            />
            {errors.lastName ? (
              <div className="error">{errors.lastName}</div>
            ) : null}
          </div>

          <label htmlFor="Phone">Phone *</label>
          <div>
            <PhoneInput
              isValid={(value) => {
                if (value.toString().startsWith("234") ? value.length <= 12 : value.length < 12 || value.length > 15) {
                  if (value.length >= 4 && value.length <= 12)
                    setPhoneerror(true);
                  return false;
                } else {
                  setPhoneerror(false);
                  return true;
                }
              }}
              style={{ backgroundColor: "none", width: "120%" }}
              className="inputPhone"
              countryCodeEditable={true}
              country={"ng"}
              value={phone}
              onChange={(event) => {
                handlePhone(event);
              }}
            />
            {phoneerror ? (
              <div className="error">Enter Valid Phone Number</div>
            ) : null}
          </div>

          <label htmlFor="firstName">Email Address *</label>
          <div>
            <input
              placeholder="Enter your email address"
              className="inputForm"
              onChange={handleChange}
              type="email"
              name="emailAddress"
              value={values.emailAddress}
            />
            {errors.emailAddress ? (
              <div className="error">{errors.emailAddress}</div>
            ) : null}
          </div>

          <div className="radioCheck">
            <CheckBtn2
              name={"terms"}
              value={
                "I confirm that I regularly access this mailbox and that this is my preferred email address to receive personal, confidential and sensitive medical information."
              }
              onClick={() => {
                terms === true ? setTerms(false) : setTerms(true);
              }}
              checked={terms === true}
              img={require("../../assets/images/check.svg").default}
              imgAct={require("../../assets/images/checkact.svg").default}
            />
          </div>

          <button type="submit" className="sumbitBtn">
            Continue
          </button>
        </form>
      </div>
    </AuthLayout>
  );
}

export default SignUp;
